/*! lazysizes - v5.3.2 */

!(function (e) {
  var t = (function (u, D, f) {
    "use strict";
    var k, H;
    if (
      ((function () {
        var e;
        var t = {
          lazyClass: "lazyload",
          loadedClass: "lazyloaded",
          loadingClass: "lazyloading",
          preloadClass: "lazypreload",
          errorClass: "lazyerror",
          autosizesClass: "lazyautosizes",
          fastLoadedClass: "ls-is-cached",
          iframeLoadMode: 0,
          srcAttr: "data-src",
          srcsetAttr: "data-srcset",
          sizesAttr: "data-sizes",
          minSize: 40,
          customMedia: {},
          init: true,
          expFactor: 1.5,
          hFac: 0.8,
          loadMode: 2,
          loadHidden: true,
          ricTimeout: 0,
          throttleDelay: 125,
        };
        H = u.lazySizesConfig || u.lazysizesConfig || {};
        for (e in t) {
          if (!(e in H)) {
            H[e] = t[e];
          }
        }
      })(),
      !D || !D.getElementsByClassName)
    ) {
      return { init: function () {}, cfg: H, noSupport: true };
    }
    var O = D.documentElement,
      i = u.HTMLPictureElement,
      P = "addEventListener",
      $ = "getAttribute",
      q = u[P].bind(u),
      I = u.setTimeout,
      U = u.requestAnimationFrame || I,
      o = u.requestIdleCallback,
      j = /^picture$/i,
      r = ["load", "error", "lazyincluded", "_lazyloaded"],
      a = {},
      G = Array.prototype.forEach,
      J = function (e, t) {
        if (!a[t]) {
          a[t] = new RegExp("(\\s|^)" + t + "(\\s|$)");
        }
        return a[t].test(e[$]("class") || "") && a[t];
      },
      K = function (e, t) {
        if (!J(e, t)) {
          e.setAttribute("class", (e[$]("class") || "").trim() + " " + t);
        }
      },
      Q = function (e, t) {
        var a;
        if ((a = J(e, t))) {
          e.setAttribute("class", (e[$]("class") || "").replace(a, " "));
        }
      },
      V = function (t, a, e) {
        var i = e ? P : "removeEventListener";
        if (e) {
          V(t, a);
        }
        r.forEach(function (e) {
          t[i](e, a);
        });
      },
      X = function (e, t, a, i, r) {
        var n = D.createEvent("Event");
        if (!a) {
          a = {};
        }
        a.instance = k;
        n.initEvent(t, !i, !r);
        n.detail = a;
        e.dispatchEvent(n);
        return n;
      },
      Y = function (e, t) {
        var a;
        if (!i && (a = u.picturefill || H.pf)) {
          if (t && t.src && !e[$]("srcset")) {
            e.setAttribute("srcset", t.src);
          }
          a({ reevaluate: true, elements: [e] });
        } else if (t && t.src) {
          e.src = t.src;
        }
      },
      Z = function (e, t) {
        return (getComputedStyle(e, null) || {})[t];
      },
      s = function (e, t, a) {
        a = a || e.offsetWidth;
        while (a < H.minSize && t && !e._lazysizesWidth) {
          a = t.offsetWidth;
          t = t.parentNode;
        }
        return a;
      },
      ee = (function () {
        var a, i;
        var t = [];
        var r = [];
        var n = t;
        var s = function () {
          var e = n;
          n = t.length ? r : t;
          a = true;
          i = false;
          while (e.length) {
            e.shift()();
          }
          a = false;
        };
        var e = function (e, t) {
          if (a && !t) {
            e.apply(this, arguments);
          } else {
            n.push(e);
            if (!i) {
              i = true;
              (D.hidden ? I : U)(s);
            }
          }
        };
        e._lsFlush = s;
        return e;
      })(),
      te = function (a, e) {
        return e
          ? function () {
              ee(a);
            }
          : function () {
              var e = this;
              var t = arguments;
              ee(function () {
                a.apply(e, t);
              });
            };
      },
      ae = function (e) {
        var a;
        var i = 0;
        var r = H.throttleDelay;
        var n = H.ricTimeout;
        var t = function () {
          a = false;
          i = f.now();
          e();
        };
        var s =
          o && n > 49
            ? function () {
                o(t, { timeout: n });
                if (n !== H.ricTimeout) {
                  n = H.ricTimeout;
                }
              }
            : te(function () {
                I(t);
              }, true);
        return function (e) {
          var t;
          if ((e = e === true)) {
            n = 33;
          }
          if (a) {
            return;
          }
          a = true;
          t = r - (f.now() - i);
          if (t < 0) {
            t = 0;
          }
          if (e || t < 9) {
            s();
          } else {
            I(s, t);
          }
        };
      },
      ie = function (e) {
        var t, a;
        var i = 99;
        var r = function () {
          t = null;
          e();
        };
        var n = function () {
          var e = f.now() - a;
          if (e < i) {
            I(n, i - e);
          } else {
            (o || r)(r);
          }
        };
        return function () {
          a = f.now();
          if (!t) {
            t = I(n, i);
          }
        };
      },
      e = (function () {
        var v, m, c, h, e;
        var y, z, g, p, C, b, A;
        var n = /^img$/i;
        var d = /^iframe$/i;
        var E = "onscroll" in u && !/(gle|ing)bot/.test(navigator.userAgent);
        var _ = 0;
        var w = 0;
        var M = 0;
        var N = -1;
        var L = function (e) {
          M--;
          if (!e || M < 0 || !e.target) {
            M = 0;
          }
        };
        var x = function (e) {
          if (A == null) {
            A = Z(D.body, "visibility") == "hidden";
          }
          return (
            A ||
            !(
              Z(e.parentNode, "visibility") == "hidden" &&
              Z(e, "visibility") == "hidden"
            )
          );
        };
        var W = function (e, t) {
          var a;
          var i = e;
          var r = x(e);
          g -= t;
          b += t;
          p -= t;
          C += t;
          while (r && (i = i.offsetParent) && i != D.body && i != O) {
            r = (Z(i, "opacity") || 1) > 0;
            if (r && Z(i, "overflow") != "visible") {
              a = i.getBoundingClientRect();
              r =
                C > a.left && p < a.right && b > a.top - 1 && g < a.bottom + 1;
            }
          }
          return r;
        };
        var t = function () {
          var e, t, a, i, r, n, s, o, l, u, f, c;
          var d = k.elements;
          if ((h = H.loadMode) && M < 8 && (e = d.length)) {
            t = 0;
            N++;
            for (; t < e; t++) {
              if (!d[t] || d[t]._lazyRace) {
                continue;
              }
              if (!E || (k.prematureUnveil && k.prematureUnveil(d[t]))) {
                R(d[t]);
                continue;
              }
              if (!(o = d[t][$]("data-expand")) || !(n = o * 1)) {
                n = w;
              }
              if (!u) {
                u =
                  !H.expand || H.expand < 1
                    ? O.clientHeight > 500 && O.clientWidth > 500
                      ? 500
                      : 370
                    : H.expand;
                k._defEx = u;
                f = u * H.expFactor;
                c = H.hFac;
                A = null;
                if (w < f && M < 1 && N > 2 && h > 2 && !D.hidden) {
                  w = f;
                  N = 0;
                } else if (h > 1 && N > 1 && M < 6) {
                  w = u;
                } else {
                  w = _;
                }
              }
              if (l !== n) {
                y = innerWidth + n * c;
                z = innerHeight + n;
                s = n * -1;
                l = n;
              }
              a = d[t].getBoundingClientRect();
              if (
                (b = a.bottom) >= s &&
                (g = a.top) <= z &&
                (C = a.right) >= s * c &&
                (p = a.left) <= y &&
                (b || C || p || g) &&
                (H.loadHidden || x(d[t])) &&
                ((m && M < 3 && !o && (h < 3 || N < 4)) || W(d[t], n))
              ) {
                R(d[t]);
                r = true;
                if (M > 9) {
                  break;
                }
              } else if (
                !r &&
                m &&
                !i &&
                M < 4 &&
                N < 4 &&
                h > 2 &&
                (v[0] || H.preloadAfterLoad) &&
                (v[0] ||
                  (!o && (b || C || p || g || d[t][$](H.sizesAttr) != "auto")))
              ) {
                i = v[0] || d[t];
              }
            }
            if (i && !r) {
              R(i);
            }
          }
        };
        var a = ae(t);
        var S = function (e) {
          var t = e.target;
          if (t._lazyCache) {
            delete t._lazyCache;
            return;
          }
          L(e);
          K(t, H.loadedClass);
          Q(t, H.loadingClass);
          V(t, B);
          X(t, "lazyloaded");
        };
        var i = te(S);
        var B = function (e) {
          i({ target: e.target });
        };
        var T = function (e, t) {
          var a = e.getAttribute("data-load-mode") || H.iframeLoadMode;
          if (a == 0) {
            e.contentWindow.location.replace(t);
          } else if (a == 1) {
            e.src = t;
          }
        };
        var F = function (e) {
          var t;
          var a = e[$](H.srcsetAttr);
          if ((t = H.customMedia[e[$]("data-media") || e[$]("media")])) {
            e.setAttribute("media", t);
          }
          if (a) {
            e.setAttribute("srcset", a);
          }
        };
        var s = te(function (t, e, a, i, r) {
          var n, s, o, l, u, f;
          if (!(u = X(t, "lazybeforeunveil", e)).defaultPrevented) {
            if (i) {
              if (a) {
                K(t, H.autosizesClass);
              } else {
                t.setAttribute("sizes", i);
              }
            }
            s = t[$](H.srcsetAttr);
            n = t[$](H.srcAttr);
            if (r) {
              o = t.parentNode;
              l = o && j.test(o.nodeName || "");
            }
            f = e.firesLoad || ("src" in t && (s || n || l));
            u = { target: t };
            K(t, H.loadingClass);
            if (f) {
              clearTimeout(c);
              c = I(L, 2500);
              V(t, B, true);
            }
            if (l) {
              G.call(o.getElementsByTagName("source"), F);
            }
            if (s) {
              t.setAttribute("srcset", s);
            } else if (n && !l) {
              if (d.test(t.nodeName)) {
                T(t, n);
              } else {
                t.src = n;
              }
            }
            if (r && (s || l)) {
              Y(t, { src: n });
            }
          }
          if (t._lazyRace) {
            delete t._lazyRace;
          }
          Q(t, H.lazyClass);
          ee(function () {
            var e = t.complete && t.naturalWidth > 1;
            if (!f || e) {
              if (e) {
                K(t, H.fastLoadedClass);
              }
              S(u);
              t._lazyCache = true;
              I(function () {
                if ("_lazyCache" in t) {
                  delete t._lazyCache;
                }
              }, 9);
            }
            if (t.loading == "lazy") {
              M--;
            }
          }, true);
        });
        var R = function (e) {
          if (e._lazyRace) {
            return;
          }
          var t;
          var a = n.test(e.nodeName);
          var i = a && (e[$](H.sizesAttr) || e[$]("sizes"));
          var r = i == "auto";
          if (
            (r || !m) &&
            a &&
            (e[$]("src") || e.srcset) &&
            !e.complete &&
            !J(e, H.errorClass) &&
            J(e, H.lazyClass)
          ) {
            return;
          }
          t = X(e, "lazyunveilread").detail;
          if (r) {
            re.updateElem(e, true, e.offsetWidth);
          }
          e._lazyRace = true;
          M++;
          s(e, t, r, i, a);
        };
        var r = ie(function () {
          H.loadMode = 3;
          a();
        });
        var o = function () {
          if (H.loadMode == 3) {
            H.loadMode = 2;
          }
          r();
        };
        var l = function () {
          if (m) {
            return;
          }
          if (f.now() - e < 999) {
            I(l, 999);
            return;
          }
          m = true;
          H.loadMode = 3;
          a();
          q("scroll", o, true);
        };
        return {
          _: function () {
            e = f.now();
            k.elements = D.getElementsByClassName(H.lazyClass);
            v = D.getElementsByClassName(H.lazyClass + " " + H.preloadClass);
            q("scroll", a, true);
            q("resize", a, true);
            q("pageshow", function (e) {
              if (e.persisted) {
                var t = D.querySelectorAll("." + H.loadingClass);
                if (t.length && t.forEach) {
                  U(function () {
                    t.forEach(function (e) {
                      if (e.complete) {
                        R(e);
                      }
                    });
                  });
                }
              }
            });
            if (u.MutationObserver) {
              new MutationObserver(a).observe(O, {
                childList: true,
                subtree: true,
                attributes: true,
              });
            } else {
              O[P]("DOMNodeInserted", a, true);
              O[P]("DOMAttrModified", a, true);
              setInterval(a, 999);
            }
            q("hashchange", a, true);
            [
              "focus",
              "mouseover",
              "click",
              "load",
              "transitionend",
              "animationend",
            ].forEach(function (e) {
              D[P](e, a, true);
            });
            if (/d$|^c/.test(D.readyState)) {
              l();
            } else {
              q("load", l);
              D[P]("DOMContentLoaded", a);
              I(l, 2e4);
            }
            if (k.elements.length) {
              t();
              ee._lsFlush();
            } else {
              a();
            }
          },
          checkElems: a,
          unveil: R,
          _aLSL: o,
        };
      })(),
      re = (function () {
        var a;
        var n = te(function (e, t, a, i) {
          var r, n, s;
          e._lazysizesWidth = i;
          i += "px";
          e.setAttribute("sizes", i);
          if (j.test(t.nodeName || "")) {
            r = t.getElementsByTagName("source");
            for (n = 0, s = r.length; n < s; n++) {
              r[n].setAttribute("sizes", i);
            }
          }
          if (!a.detail.dataAttr) {
            Y(e, a.detail);
          }
        });
        var i = function (e, t, a) {
          var i;
          var r = e.parentNode;
          if (r) {
            a = s(e, r, a);
            i = X(e, "lazybeforesizes", { width: a, dataAttr: !!t });
            if (!i.defaultPrevented) {
              a = i.detail.width;
              if (a && a !== e._lazysizesWidth) {
                n(e, r, i, a);
              }
            }
          }
        };
        var e = function () {
          var e;
          var t = a.length;
          if (t) {
            e = 0;
            for (; e < t; e++) {
              i(a[e]);
            }
          }
        };
        var t = ie(e);
        return {
          _: function () {
            a = D.getElementsByClassName(H.autosizesClass);
            q("resize", t);
          },
          checkElems: t,
          updateElem: i,
        };
      })(),
      t = function () {
        if (!t.i && D.getElementsByClassName) {
          t.i = true;
          re._();
          e._();
        }
      };
    return (
      I(function () {
        H.init && t();
      }),
      (k = {
        cfg: H,
        autoSizer: re,
        loader: e,
        init: t,
        uP: Y,
        aC: K,
        rC: Q,
        hC: J,
        fire: X,
        gW: s,
        rAF: ee,
      })
    );
  })(e, e.document, Date);
  (e.lazySizes = t),
    "object" == typeof module && module.exports && (module.exports = t);
})("undefined" != typeof window ? window : {});
// Cookies
function createCookie(cookieName, cookieValue, daysToExpire) {
  var date = new Date();
  date.setTime(date.getTime() + daysToExpire * 24 * 60 * 60 * 1000);
  document.cookie =
    cookieName + "=" + cookieValue + "; expires=" + date.toGMTString();
}
function accessCookie(cookieName) {
  var name = cookieName + "=";
  var allCookieArray = document.cookie.split(";");
  for (var i = 0; i < allCookieArray.length; i++) {
    var temp = allCookieArray[i].trim();
    if (temp.indexOf(name) == 0)
      return temp.substring(name.length, temp.length);
  }
  return "";
}
function setCookieCloseBox(cookieName) {
  createCookie(cookieNaam, "closed", days); // create cookie
  document.body.removeEventListener("mouseleave", userLeave); // prevent box from reappearing
  document.body.classList.remove("newsletterbox-active"); // hide newsletter box
}
// Newsletter
function newsletterPopup() {
  var newsletterBox = document.getElementById("newsletterbox");
  if (newsletterBox) {
    var cookieNaam = "smfk-newspopup";
    var isCookie = accessCookie(cookieNaam);

    var days = newsletterBox.dataset.expire; // Get days from data-expire
    var cdown = newsletterBox.dataset.cdown; // Get count down from data-cdown
    var tnx = newsletterBox.dataset.thanks; // Get thanks from data-tnx
    var err = newsletterBox.dataset.err; // Get error from data-err
    var mail = newsletterBox.dataset.mail; // Get mail from data-mail

    if (days === undefined) {
      var days = 7;
    }
    if (cdown === undefined) {
      var cdown = 30000;
    }
    if (tnx === undefined) {
      var tnx = "Thanks for signing up!";
    }
    if (err === undefined) {
      var err = "There was an error in submitting the form.";
    }
    if (mail === undefined) {
      var mail = "Please fill in your email address.";
    }

    // Countdown: show after X sec
    function countDownr(event) {
      setTimeout(function () {
        document.body.classList.add("newsletter-active"); // show newsletter box
      }, cdown);
    }

    // Check if user tries to leave from top
    function userLeave(event) {
      if (event.clientY <= 0) {
        document.body.classList.add("newsletter-active"); // show newsletter box
      }
    }

    // If cookie is not set show newsletter box
    if (isCookie !== "closed") {
      countDownr(); // start countdown
    }

    // If is challenge page
    var challengeUrl = window.location.origin + "/challenge#contact_form";
    var currentUrl = window.location;
    if (currentUrl == challengeUrl) {
      document.getElementById("newsletterbox").style.display = "none";
    }

    // Set cookie for "X" days and close newsletter box
    function setCookieNclose() {
      createCookie(cookieNaam, "closed", days); // create cookie
      document.body.removeEventListener("mouseleave", userLeave); // prevent box from reappearing
      document.body.classList.remove("newsletter-active"); // hide newsletter box
    }

    // On click Set cookie for "X" days and close newsletter box
    document
      .getElementById("closenewsletter")
      .addEventListener("click", function () {
        setCookieNclose();
      });

    // Newsletter submit thru AJAX
    // TODO: convert in Vanilla JS
    $("form.contact-form").submit(function () {
      $("p.msg.is-green, p.msg.is-red").remove();
      if ($(this).find('input[type="email"]').val() !== "") {
        var data = $(this).serialize();
        $.ajax({
          type: "POST",
          url: "/contact#contact_form",
          data: data,
          crossDomain: true,
          success: function (response, textStatus, xhr) {
            $(".contact-form").append(
              '<p class="msg is-green">' + tnx + "</p>"
            );
            setTimeout(function () {
              setCookieNclose();
            }, 3000);
          },
          error: function (XMLHttpRequest, textStatus, errorThrown) {
            $(".contact-form").append('<p class="msg is-red">' + err + "</p>");
          },
        });

        // If customer is challenged
        if (response.status == 429) {
          var challengeUrl = window.location.origin + "/challenge#";
          window.location = challengeUrl;
        }
      } else {
        $(this).append('<p class="msg is-red">' + mail + "</p>");
      }
      return false;
    });

    // When customer is back from challenge
    var checkURL = [
      "?customer_posted=true",
      "?contact%5Btags%5D=newsletter&form_type=customer",
    ];
    for (var i = 0; i < checkURL.length; i++) {
      if (window.location.href.indexOf(checkURL[i]) > -1) {
        // Show newsletter box
        document.body.classList.add("newsletter-active");
        setTimeout(function () {
          setCookieNclose();
        }, 5000);
      }
    }
  }
}
// Toggle Body Class
let toggleBodyClass = function (arg) {
  document.body.classList.toggle(arg);
};
// Get Element Height
function getElementHeight(targetElement, appendTo, cssVar) {
  let element = document.querySelector(targetElement);

  if (element) {
    let elementHeight = element.offsetHeight;
    document
      .querySelector(appendTo)
      .style.setProperty(cssVar, `${elementHeight}px`);
  }
}

// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
function getSetVh() {
  let vh = window.innerHeight * 0.01;
  document.body.style.setProperty("--vh", `${vh}px`);
}

window.addEventListener("resize", () => {
  getSetVh();
});

function initLoading() {
  document.body.classList.remove("js-unload");
  window.onpageshow = function (evt) {
    // Removes unload class when returning to cached page
    if (evt.persisted) {
      document.body.classList.remove("js-unload");
    }
    initDOMLoading(window.document);
  };
}

function initDOMLoading(container) {
  try {
    if (window.document.body.dataset["transitions"] == "false") {
      console.log("Dom Transition Disabled");
      return;
    }
  } catch (err) {
    console.error(err);
  }
  container
    .querySelectorAll(
      'a[href^="mailto:"], a[href^="#"], a[data-transition="false"], a[target="_blank"], a[href*="youtube.com/watch"], a[href*="youtu.be/"], a[download]'
    )
    .forEach((el) => {
      el.classList.add("js-no-transition");
    });
  container.querySelectorAll("a:not(.js-no-transition)").forEach((el) => {
    el.addEventListener("click", function (evt) {
      if (evt.metaKey) return true;
      var src = el.getAttribute("href");
      if (src) {
        // Bail if it's a hash link
        if (src.indexOf(location.pathname) >= 0 && src.indexOf("#") >= 0) {
          return true;
        }

        evt.preventDefault();
        document.body.classList.add("js-unload");
        window.setTimeout(function () {
          location.href = src;
        }, 50);
      }
    });
  });
  container
    .querySelectorAll('form[action="/account/login"], form[action="/account"]')
    .forEach((el) => {
      el.addEventListener("submit", function (evt) {
        evt.preventDefault();
        document.body.classList.add("js-unload");
        window.setTimeout(function () {
          evt.target.submit();
        }, 50);
      });
    });
}
// Wrap Tables
function wrapTable(options) {
  options.tables.forEach(function (table) {
    var wrapper = document.createElement("div");
    wrapper.classList.add(options.tableWrapperClass);

    table.parentNode.insertBefore(wrapper, table);
    wrapper.appendChild(table);
  });
}

// Toggle
let toggleClass = function (qSelectors, bodyClass, prevent = false) {
  let elArray = document.querySelectorAll(qSelectors);
  elArray.forEach(function (e) {
    e.addEventListener("click", function (evt) {
      if (prevent) {
        evt.preventDefault();
      }
      toggleBodyClass(bodyClass);
    });
  });
};
// Menu
let toggleMenu = function () {
  toggleClass(".fire-menu, .shrink-menu", "open-menu");
};
// Menu
let toggleSearch = function () {
  toggleClass(".fire-search, .shrink-search", "open-search");
};
// Cart
let toggleCart = function () {
  toggleClass(".carto-icon, .cartc", "open-cart", true);
  var mainElem = document.querySelector("main");
  if (mainElem) {
    mainElem.style.overflowY = "hidden";
  }
  const clsbtn = document.querySelector(".cartc");
  if (clsbtn) {
    clsbtn.addEventListener("click", () => {
      document.body.classList.remove("hideheader");
      if (mainElem) {
        mainElem.style.overflowY = "";
      }
    });
  }
};

// Dropdown menu header
function dropdownMenu() {
  const detailsElements = document.querySelectorAll("details.lv1");

  function handleClickOnDetails() {
    // close all details
    let detailsOpened = document.querySelectorAll("details[open].lv1");

    for (const item of detailsOpened) {
      if (this != item) {
        item.removeAttribute("open");
      }
    }
  }

  detailsElements.forEach(function (item) {
    item.addEventListener("click", handleClickOnDetails);
  });
}

// Close <details> when you click outside
var details = [...document.querySelectorAll("details")];
document.addEventListener("click", function (e) {
  if (!details.some((f) => f.contains(e.target))) {
    details.forEach((f) => f.removeAttribute("open"));
  } else {
    details.forEach((f) =>
      !f.contains(e.target) ? f.removeAttribute("open") : ""
    );
  }
});

// update button price on variant change
function updatePrice(obj, idd) {
  var uid = obj.options[obj.selectedIndex].getAttribute("data-price");
  var pb = document.querySelector(".uprice" + idd);
  pb.innerText = uid;
}

function selectOptions(obj, idd) {
  updatePrice(obj, idd);
}

// AJAX cart.js
// AJAX cart init can be located in theme.liquid
function ajaxCart(obj) {
  // Show loading feedback
  obj.classList.add("loading");
  // on cart request success
  $(document).ajaxSuccess(function (event, jqxhr, settings) {
    if (
      settings.url.includes("/cart/add.js") ||
      settings.url.includes("/cart/change.js")
    ) {
      // on cart request complete (just in case)
      $(document).on("cart.requestComplete", function (event, cart) {
        // Update # of items in cart
        /*
        document
          .getElementById("counter")
          .setAttribute("data-count", cart.item_count);
          */
        // Open cart
        //document.body.classList.add("open-cart");
        //document.body.classList.add("hideheader");
        // Remove loading feedback
        obj.classList.remove("loading");
        var btnStringEles = $(obj).find(".buttonString");
        var productForm = $(obj).closest(".product-form");
        if (btnStringEles.length > 0) {
          var btnStringEle = btnStringEles.first();
          console.log("btnStringEle", btnStringEle);
          const copyText = btnStringEle.text();
          btnStringEle.text(window.theme.strings.cart.item_added);
          setTimeout(() => {
            btnStringEle.text(copyText);
          }, "1500");
        }
        if (productForm) {
          productForm.addClass("item-added");
        }
      });
    }
  });

  // on cart request error
  $(document).ajaxError(function (event, jqxhr, settings) {
    if (
      settings.url.includes("/cart/add.js") ||
      settings.url.includes("/cart/change.js")
    ) {
      obj.classList.remove("loading"); // Remove loading feedback
      console.log(jqxhr.responseJSON);
      alert(jqxhr.responseJSON.description);
      event.stopImmediatePropagation();
    }
  });
}

// Update # of items in cart
/*
$(document).on("cart.requestComplete", function (event, cart) {
  document
    .getElementById("counter")
    .setAttribute("data-count", cart.item_count);
});
*/

// Render SlideShow
function initSlideShow(ele, options = undefined) {
  if (window.Splide) {
    var config = {
      destroy: true,
      breakpoints: {
        777: {
          perMove: 1,
          type: "loop",
          perPage: 1,
          arrows: false,
          pagination: false,
          destroy: false,
        },
      },
    };
    if (options) {
      config = options;
    }

    return new window.Splide(ele, config).mount();
  } else {
    setTimeout(() => {
      return initSlideShow(ele);
    }, 1000);
  }
}

// Render SlideShow
// Render SlideShow
function registerProductSlideShow(ele, options = undefined) {
  function calculateSlideshowHeight(splideEle) {
    var splideTrack = splideEle.querySelector(".splide__track");
    var currentSlide = splideTrack.querySelector(".splide__slide.is-active");
    if (currentSlide) {
      var slideMedia = currentSlide.querySelector(".product-media-height");
      splideTrack.style.maxHeight = slideMedia.offsetHeight + "px";
    } else {
      if (splideTrack !== null) {
        splideTrack.style.removeProperty("max-height");
      }
    }
  }
  var productSplide = function productSplide(Splide) {
    function handleMounted() {
      if (window.innerWidth > 777) {
        Splide.destroy(false);
      } else {
        calculateSlideshowHeight(Splide.root);
        Splide.root.classList.add("splide-enabled");
      }
    }

    function handleDestroy() {
      var splideTrack = Splide.root.querySelector(".splide__track");
      splideTrack.style.removeProperty("max-height");
      Splide.root.classList.remove("splide-enabled");
    }

    function handleMoved(newIndex) {
      calculateSlideshowHeight(Splide.root);
      document.body.dispatchEvent(
        new CustomEvent("productSlideShow:moved", {
          detail: { length: Splide.length, newIndex: newIndex },
        })
      );
    }
    return {
      mount: function mount() {
        Splide.on("mounted", handleMounted);
        Splide.on("destroy", handleDestroy);
        Splide.on("moved", handleMoved);
      },
    };
  };
  if (window.Splide) {
    var config = {
      destroy: true,
      arrows: false,
      pagination: false,
      breakpoints: {
        777: {
          perMove: 1,
          type: "loop",
          perPage: 1,
        },
      },
    };
    if (options) {
      config = options;
    }
    return new window.Splide(ele, config).mount({
      SplidePDP: productSplide,
    });
  } else {
    setTimeout(() => {
      return registerProductSlideShow(ele);
    }, 1000);
  }
}

function initProductSlideshow() {
  const splideElem = document.querySelector(".splide.product-splide");
  if (splideElem) {
    return window.registerProductSlideShow(splideElem);
  }
}
function registerHeroSlideShow(ele, options = undefined) {
  function calculateSlideshowHeight(splideEle) {
    var splideTrack = splideEle.querySelector(".splide__track");
    var currentSlide = splideTrack.querySelector(".splide__slide.is-active");
    if (currentSlide) {
      var slideMedia = currentSlide.querySelector(".product-media-height");
      splideTrack.style.maxHeight = slideMedia.offsetHeight + "px";
    } else {
      if (splideTrack !== null) {
        splideTrack.style.removeProperty("max-height");
      }
    }
  }
  if (window.Splide) {
    var config = {
      pagination: false,
      perPage: 1,
      arrowPath: "M 30.875357 20.399994 L 29.637678 21.637671 L 12.113035 39.162315 L 10.875358 40.399994 L 8.400002 37.924637 L 9.637679 36.686962 L 25.924644 20.399994 L 9.637679 4.113026 L 8.400002 2.875351 L 10.875358 0.399994 L 12.113035 1.637672 L 29.637678 19.162317 L 30.875357 20.399994 Z",
    };
    if (options) {
      config = {
        ...config,
        ...options,
      };
    }
    return new window.Splide(ele, config).mount();
  } else {
    setTimeout(() => {
      return registerHeroSlideShow(ele);
    }, 1000);
  }
}
function initHeroSlideshow() {
  const splideElem = document.querySelector(".splide.splide-slideshow");
  if (splideElem) {
    var options = undefined;
    if(splideElem.dataset['splideOptions']){
      options = JSON.parse(splideElem.dataset['splideOptions']);
    }
    return registerHeroSlideShow(splideElem, options);
  }
}


function registerProductSlider(ele, options = undefined) {
  var productSplide = function productSplide(Splide) {
    function handleMounted() {
      if (window.innerWidth > 770) {
        Splide.root.classList.add("splide-enabled");
      } else {
        Splide.destroy(false);
      }
    }

    function handleDestroy() {
      var splideTrack = Splide.root.querySelector(".splide__track");
      splideTrack.style.removeProperty("max-height");
      Splide.root.classList.remove("splide-enabled");
    }

    return {
      mount: function mount() {
        Splide.on("mounted", handleMounted);
        Splide.on("destroy", handleDestroy);
      },
    };
  };
  if (window.Splide) {
    var config = {
      pagination: false,
      mediaQuery: "min",
      drag: "free",
      perPage: 2,
      arrows: false,
      breakpoints: {
        770: {
          perPage: 4,
        },
      },
    };
    if (options) {
      config = Object.assign(config, options);
    }
    return new window.Splide(ele, config).mount();
  } else {
    setTimeout(() => {
      return registerProductSlider(ele);
    }, 1000);
  }
}
function parseSplideOptionData(data) {
  try {
    var options = JSON.parse(data);
    return options;
  } catch (e) {
    console.error(e);
  }
}
function initGSProductSlider() {
  const splideElem = document.querySelectorAll(".product-slider-splide");
  splideElem.forEach(function (item) {
    var options = undefined;
    if (item.dataset["splideOptions"] != undefined) {
      options = parseSplideOptionData(item.dataset["splideOptions"]);
    }
    return registerProductSlider(item, options);
  });
}

function initMobileNavigation() {
  const mobNav = document.querySelector(".mobnav");
  document.querySelectorAll("[nav-button]").forEach(function (item) {
    item.onclick = function (evt) {
      evt.preventDefault();
      mobNav.querySelector(
        `[level="${item.getAttribute("nav-level")}"]`
      ).innerHTML = item.parentElement.querySelector("[child-nav]").innerHTML;
      mobNav.setAttribute("current-level", item.getAttribute("nav-level"));
    };
  });

  document.querySelector("[nav-button-back]").onclick = function (evt) {
    if (mobNav.getAttribute("current-level") > 1) {
      mobNav.setAttribute(
        "current-level",
        parseInt(mobNav.getAttribute("current-level")) - 1
      );
    }
  };
}

function initAllCollapseTab() {
  document.querySelectorAll("[collapse-tab]").forEach(function (item) {
    var content = item.querySelector("[collapse-content]");
    item.querySelector("[collapse-switch]").onclick = function (evt) {
      evt.preventDefault();
      item.classList.toggle("open");
      if (content.style.maxHeight) {
        content.style.maxHeight = null;
      } else {
        content.style.maxHeight = content.scrollHeight + "px";
      }
    };
  });
}

class MICSlider extends HTMLElement {
  constructor() {
    super();
    let isDown = false;
    let startX;
    let scrollLeft;
    if (this.checkMobile()) {
      this.style.overflowX = "auto";
    } else {
      this.querySelectorAll("a").forEach(function (ele) {
        ele.onclick = function (evt) {
          if (isDown) {
            evt.preventDefault();
          }
        };
      });
      this.addEventListener("mousedown", (e) => {
        isDown = true;
        this.classList.add("active");
        startX = e.pageX - this.offsetLeft;
        scrollLeft = this.scrollLeft;
      });

      this.addEventListener("mouseleave", () => {
        settim;
        isDown = false;
        set;
        this.classList.remove("active");
      });

      this.addEventListener("mouseup", () => {
        isDown = false;
        this.classList.remove("active");
      });

      this.addEventListener("mousemove", (e) => {
        if (!isDown) return; // stop the fn from running
        e.preventDefault();
        const x = e.pageX - this.offsetLeft;
        const walk = (x - startX) * 2;
        this.scrollLeft = scrollLeft - walk;
      });

      //   touchEvents

      this.addEventListener("touchstart", (e) => {
        isDown = true;
        this.classList.add("active");
        startX = e.pageX - this.offsetLeft;
        scrollLeft = this.scrollLeft;
      });

      this.addEventListener("touchend", () => {
        isDown = false;
        this.classList.remove("active");
      });

      this.addEventListener("touchcancel", () => {
        isDown = false;
        this.classList.remove("active");
      });

      this.addEventListener("touchmove", (e) => {
        if (!isDown) return; // stop the fn from running
        e.preventDefault();
        const x = e.pageX - this.offsetLeft;
        const walk = (x - startX) * 2;
        this.scrollLeft = scrollLeft - walk;
      });
    }
  }

  checkMobile() {
    let check = false;
    (function (a) {
      if (
        /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(
          a
        ) ||
        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
          a.substr(0, 4)
        )
      )
        check = true;
    })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
  }
}

function collectionSortFilter() {
  window.Shopify.queryParams = {};

  // Preserve existing query parameters
  if (window.location.search.length) {
    var params = location.search.substr(1).split("&");

    for (var i = 0; i < params.length; i++) {
      var keyValue = params[i].split("=");

      if (keyValue.length) {
        window.Shopify.queryParams[decodeURIComponent(keyValue[0])] =
          decodeURIComponent(keyValue[1]);
      }
    }
  }

  // Update sort_by query parameter on select change
  document.querySelectorAll("[sort-options]").forEach(function (item) {
    item.addEventListener("click", function (e) {
      var value = item.getAttribute("value");

      Shopify.queryParams.sort_by = value;
      location.search = new URLSearchParams(Shopify.queryParams).toString();
    });
  });
}

function collectionFilterDrawer() {
  var drawer = document.querySelector("[filter-drawer]");
  if (drawer) {
    document
      .querySelectorAll("[filter-drawer-switch]")
      .forEach(function (item) {
        drawer
          .querySelector("[close-drawer]")
          .addEventListener("click", function (e) {
            document.body.classList.remove("open-drawer");
            drawer.setAttribute("drawer-type", "");
          });
        item.addEventListener("click", function (e) {
          document.body.classList.add("open-drawer");
          drawer.setAttribute(
            "drawer-type",
            item.getAttribute("drawer-target")
          );
        });
      });
  }
}
function initLazyLoadPictures() {
  let pictures = document.querySelectorAll("picture.lazyload");
  pictures.forEach(function (ele) {
    ele.classList.add("lazyload--loading");
    var imgTag = ele.querySelector("img");
    imgTag.addEventListener("load", function () {
      ele.classList.remove("lazyload", "lazyload--loading");
    });
  });
}
function themeColorSwitch() {
  const themeToggle = document.querySelector("#theme-toggle");
  if (themeToggle) {
    themeToggle.addEventListener("click", function (e) {
      if (document.body.getAttribute("data-theme") === "dark") {
        document.body.setAttribute("data-theme", "light");
        localStorage.setItem("color-schema", "light");
      } else {
        document.body.setAttribute("data-theme", "dark");
        localStorage.setItem("color-schema", "dark");
      }
    });
  }
}
/*** init app */
function app() {
  initLazyLoadPictures();
  getSetVh(); // get Viewport Height
  dropdownMenu(); // Dropdown menu
  newsletterPopup(); // Newsletter popup
  toggleMenu(); // toggle Menu
  toggleSearch(); // toggle Search
  toggleCart(); // toggle Cart
  Marquee3k.init(); // Start noticer
  var tableSelectors = ".rte table";
  wrapTable({
    tables: document.querySelectorAll(tableSelectors),
    tableWrapperClass: "table-wrapper",
  });

  initGSProductSlider();
  initProductSlideshow();
  initMobileNavigation();
  initLoading();
  customElements.define("mic-slider", MICSlider);
  initAllCollapseTab();
  collectionSortFilter();
  collectionFilterDrawer();
  themeColorSwitch();
  initHeroSlideshow();
}

/*** on DOM ready **/
document.addEventListener("DOMContentLoaded", () => {
  app();
});
